import { render, staticRenderFns } from "./CardPagamentos.vue?vue&type=template&id=173f6647&"
import script from "./CardPagamentos.vue?vue&type=script&lang=js&"
export * from "./CardPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports